<template>

<app-view-list-field align="center" :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-rating :value="value" class="rating" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isCondensed', 'isSticky'],

	computed: {

		value: function() {

			return this.item.user.rating_avg

		}

	}

}

</script>

<style scoped>

.rating {
    width: 48px;
    height: 48px;
    line-height: 48px;
}

.field.is-condensed .rating {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
}

</style>